import { UserRoleEnum } from "../../../helpers/enums"

export interface RoleCard {
    title: string,
    subTitle: string,
    desc: string[]
}

export const Manager = {
    "title": "registerOperator.role.manager",
    "subtitle": "registerOperator.role.roles",
    "desc": [
        'registerOperator.role.gestioneUtenzaWeb',
        'registerOperator.role.impersonificaUtente',
        'registerOperator.role.ricercaUtenzaWeb',
        'registerOperator.role.autolettura',
        'registerOperator.role.creazioneNuovaUtenza',
        'registerOperator.role.storicoAutoletture'
    ]
}

export const OperatoreBackOffice = {
    "title": "Operatore back office",
    "subtitle": "registerOperator.role.roles",
    "desc": [
        'registerOperator.role.gestioneUtenzaWeb',
        'registerOperator.role.impersonificaUtente',
        'registerOperator.role.ricercaUtenzaWeb',
        'registerOperator.role.autolettura',
        'registerOperator.role.storicoAutoletture',
        'registerOperator.role.creazioneUtenteComunale'
    ]
}


export const OperatoreCommunale = {
    "title": "Operatore comunale",
    "subtitle": "registerOperator.role.roles",
    "desc": [
        'registerOperator.role.gestionePratiche'
    ]
}


export interface BackOfficeSignUpReq {
    username: string,
    name: string,
    surname: string,
    email: string
    role: UserRoleEnum,
    operatorCity: string
}


export class UserOpearatorsReq {
    static makeData(data:any) : BackOfficeSignUpReq {
        return {
            'username': data.username,
            'name': data.name,
            'surname': data.surname,
            'email': data.email,
            'role': data.role,
            'operatorCity': data.operatorCity || ''
        } as BackOfficeSignUpReq
    }
}
